export default __webpack_public_path__ + "static/media/target_audience.aec634e2.jpg";